<template>
    <div class="dib mb30 vat" :style="{width: width + '%',}" :class="{mr4: mr}">
        <p v-if="title" class="fs18 fw500" style="margin-bottom: 10px;">{{title}}</p>
        <el-radio-group v-model="currentValue" :size="size">
            <el-radio-button label="Y"></el-radio-button>
            <el-radio-button label="N"></el-radio-button>
        </el-radio-group>
    </div>
</template>
<script>
export default {
    name: 'uinput',
    props: {
        title: { type: String, defualt: null},
        width: { type: Number, default: 45 },
        value: { type: String, default: 'N' },
        size: { type: String, default: '' },
        mr: { type: Boolean, default: true },
    },
    data() {
        return {
            currentValue: this.value, //? 'Y' : 'N',
        };
    },
    watch: {
        value() {
            this.currentValue = this.value; // ? 'Y' : 'N';
        },
        currentValue() {
            this.$emit('update:value', this.currentValue);
            this.$emit('input', this.currentValue);
        },
    }
}
</script>
